import axios from "axios";
import { ENDPOINT_FEATURES, ENDPOINT_FEATURES_UPDATE } from "../../constants";
import { ApiResponse } from "../types";
import { handleApiError } from "../../utils/error_handler";

// Retrieve features data
export async function retrieveFeaturesData() : Promise<{}> {
    try {
        const res = await axios.get<ApiResponse<{}>>(ENDPOINT_FEATURES);
        if (res.data.Code !== '200') {
            throw handleApiError({ response: { data: res.data } });
        }
        return res.data.Msg as {} || {};
    } catch (error: any) {
        throw handleApiError(error);
    }
}

export async function updateFeaturesData(data:any) : Promise<void> {
    try {
        const res = await axios.post<ApiResponse<void>>(ENDPOINT_FEATURES_UPDATE, data);
        if (res.data.Code !== '200') {
            throw handleApiError({ response: { data: res.data } });
        }
    } catch (error: any) {
        throw handleApiError(error);
    }
}